import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { useAppSession } from "../session";

export const fetchSession = createServerFn({ method: "GET" }).handler(async () => {
	// We need to auth on the server so we have access to secure cookies
	const session = await useAppSession();

	return session.data;
});

export const sessionQueryOptions = () =>
	queryOptions({
		queryKey: ["session"],
		queryFn: fetchSession,
	});
